import api from "./axios"; 

// 인허가 목록 가져오기
export const getPermits = async (params = {}) => {
  const res = await api.get("/permit/doc/", { params });
  return res.data.results || res.data;  
};

// 인허가 상세 조회
export const getPermit = async (id) => {
  const res = await api.get(`/permit/doc/${id}/`);
  return res.data;
};

// 인허가 등록
export const createPermit = async (data) => {
  const res = await api.post("/permit/doc/", data);
  return res.data;
};

// 인허가 수정
export const updatePermit = (dns, data) => {
  return api.patch(`/permit/doc/${dns}/`, data);
};


// 인허가 삭제
export const deletePermit = async (dns) => {
  await api.delete(`/permit/doc/${dns}/`);
};

// 첨부파일 업로드
export const uploadPermitFile = async ({ permit, file }) => {
  const formData = new FormData();
  formData.append("permit", permit);
  formData.append("file", file);

  const res = await api.post("permit/files/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};


// // 첨부파일 삭제
// export const deletePermitFile = async (id) => {
//   await api.delete(`/permit/files/${id}/`);
// };

// // 첨부파일 전체 삭제
// export const deletePermitAllFiles = async (permitId) => {
//   const res = await api.delete(`/permit/files/delete_by_permit/?permit=${permitId}`);
//   return res.data;
// };

// 엑셀 업로드
export const uploadPermitExcel = async (formData) => {
  return await api.post("permit/doc/upload-excel/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// 엑셀 템플릿 다운로드
export const downloadPermitTemplate = async () => {
  return await api.get("permit/doc/download-template/", {
    responseType: "blob", // 파일 다운로드시 필수
  });
};